var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.0001V1.90008C1 1.90008 1.875 1.00006 4.5 1.00006C7.125 1.00006 8.875 2.80006 11.5 2.80006C14.125 2.80006 15 1.90006 15 1.90006V12.7001C15 12.7001 14.125 13.6001 11.5 13.6001C8.875 13.6001 7.125 11.8001 4.5 11.8001C1.875 11.8001 1 12.7001 1 12.7001",
    fill: "#D62D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.0001V1.90008C1 1.90008 1.875 1.00006 4.5 1.00006C7.125 1.00006 8.875 2.80006 11.5 2.80006C14.125 2.80006 15 1.90006 15 1.90006V12.7001C15 12.7001 14.125 13.6001 11.5 13.6001C8.875 13.6001 7.125 11.8001 4.5 11.8001C1.875 11.8001 1 12.7001 1 12.7001",
    stroke: "#D62D2D",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRace);
export default __webpack_public_path__ + "static/media/race.04f5dc4b4776361380c039a9d9b9e60b.svg";
export { ForwardRef as ReactComponent };